import * as React from 'react';
import { I as Icon } from './SvgIcon-f1131561.js';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm0 3.6a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1-3.6-3.6c0-2 1.6-3.6 3.6-3.6zm0 17a8.6 8.6 0 0 1-7.2-3.8c0-2.4 4.8-3.7 7.2-3.7 2.4 0 7.2 1.3 7.2 3.7a8.6 8.6 0 0 1-7.2 3.8z"
  })));
};

var Account = Icon(SvgAccount);

export { Account as A };
//# sourceMappingURL=Account-91a73b66.js.map
